import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import useApiRequest from '../../store/slices/hook/useApiRequest';
import Button from '../common/Button';
import Input from '../common/Input';
import { selectBlogTypeSlide, setSelectedBlogType, toggleBlogTypeSlide } from '../../store/slices/common';
import SlideOver from '../SlideOver';
import { createBlogType, updateBlogType } from '../../store/slices/api/inner/blogTypeSlice';

const BlogTypeForm = ({
    defaultData,
    fetchData,
}) => {
    const BlogTypeIsOpen = useSelector(selectBlogTypeSlide);
    const dispatch = useDispatch();

    const defaultValues = {
        blogTypeId: defaultData?.blog_category_id ?? "",
        blogCategoryName: defaultData?.blog_category_name ?? "",
    }

    const afterAPICall = (response) => {
        fetchData()
        dispatch(toggleBlogTypeSlide())
        dispatch(setSelectedBlogType(null))
    }

    const beforeAPICall = (data) => {
        return {
            success: true,
            refactoredData: {
                blogTypeId: defaultData?.blog_category_id ?? "",
                ...data,
            }
        }
    }
    const { isLoading, control, handleSubmit, setValue } = useApiRequest({
        apiAction: defaultData ? updateBlogType : createBlogType,
        defaultValues,
        clearForm: true,
        beforeAPICall,
        afterAPICall,
    });

    useEffect(() => {
        if (defaultData) {
            setValue('blogTypeId', defaultData?.blog_category_id ?? "");
            setValue('blogCategoryName', defaultData.blog_category_name);
        } else {
            setValue('blogTypeId', "");
            setValue('blogCategoryName', "")
        }
    }, [defaultData, setValue]);

    return (
        <SlideOver isOpen={BlogTypeIsOpen}  toggleOpen={toggleBlogTypeSlide} panelName={defaultData ? "Update Blog Type" : "Add Blog Type"}>
            <form onSubmit={handleSubmit}>
                <Input
                    control={control}
                    name="blogCategoryName"
                    rules={{
                        required: "this field is required"
                    }}
                    label="Name"
                />
            

                <div className="flex justify-end my-6">
                    <Button isLoading={isLoading}>
                        {defaultData ? "Save changes" : "Submit"}
                    </Button>
                </div>
            </form>
        </SlideOver>
    )
}

export default BlogTypeForm